<h1>Generic Errors</h1>

<dx-data-grid biz-grid
  #grid
  exportFileName="Errors"
  [dataSource]="allErrors"
  [selectedRowKeys]="[]">
  <dxo-selection mode="single"></dxo-selection>
  <dxi-column caption="Time" dataField="createdDate" dataType="date" format="longDateLongTime" sortOrder="asc"></dxi-column>
  <dxi-column caption="Category" dataField="category" dataType="string"></dxi-column>
  <dxi-column caption="Error Message" dataField="errorMessage" dataType="string"></dxi-column>
  <dxi-column caption="Additional Info" dataField="additionalInfo" cellTemplate="additionalInfoTemplate"></dxi-column>

  <div *dxTemplate="let cell of 'additionalInfoTemplate'">
    <span title="{{cell.value | json}}">{{cell.value | json}}</span>
  </div>
</dx-data-grid>

<hr />
Number of generic errors:
<span id="error_count">
  {{ genericErrors.length }}
</span>
<br />
Number of http errors:
<span id="http_error_count">
  {{ httpErrors.length }}
</span>

@if (grid.selectedRowKeys.length) {
  <div id="errorInfo">
    <style type="text/css">
      .tg {
      border-collapse: collapse;
      border-spacing: 0;
      padding-top: 20px;
    }
    .tg td {
    border-color: black;
    border-style: solid;
    border-width: 1px;
    font-family: Arial, sans-serif;
    font-size: 14px;
    overflow: hidden;
    padding: 10px 5px;
    word-break: normal;
  }
  .tg th {
  border-color: black;
  border-style: solid;
  border-width: 1px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  overflow: hidden;
  padding: 10px 5px;
  word-break: normal;
}
.tg .tg-1wig {
font-weight: bold;
text-align: left;
vertical-align: top
}
.tg .tg-0lax {
text-align: left;
vertical-align: top
}
</style>
<table class="tg">
  <tbody>
    <tr>
      <th class="tg-1wig">Timestamp</th>
      <th class="tg-0lax">
        {{
        grid.instance.getSelectedRowsData()[0].createdDate
        }}
      </th>
    </tr>
    <tr>
      <td class="tg-1wig">Category</td>
      <th class="tg-0lax">
        {{
        grid.instance.getSelectedRowsData()[0].category
        }}
      </th>
    </tr>
    <tr>
      <td class="tg-1wig">Error message</td>
      <th class="tg-0lax">
        {{
        grid.instance.getSelectedRowsData()[0].errorMessage
        }}
      </th>
    </tr>
    <tr>
      <td class="tg-1wig">Additional info</td>
      <th class="tg-0lax">
        {{
        grid.instance.getSelectedRowsData()[0].additionalInfo
        }}
      </th>
    </tr>
  </tbody>
</table>
</div>
}

